<template>
    <div class="l-rblock" >
        <span v-if="disabled && printMode" class="showText">{{showValue}}</span>
        <l-tree-select
            v-else-if="!multiple"
            v-model="selectValue"
            :options="myOptions"
            :placeholder="$t(placeholder)"
            :size="size"
            :clearable="disabled?false:clearable"
            :disabled="disabled"

            @change="handleChange"
            >
            <template #prefix v-if="canSelectCurrent && !disabled">
                <div class="flex pointer" style="justify-content: center;height: 100%;" :title="$t(currentName)" @click.stop="selectCurrent">
                    <i class="learun-icon-lock" :style="{'color': hasCurrent ? '#0D68FF' : '#8c8c8c'}"></i>
                </div>
            </template>
        </l-tree-select> 
        <template v-else>
            <template v-if="mode == 'normal'">
                <span v-if="disabled && printMode" class="showText">{{showValue}}</span>
                <template v-else>
                    <el-input
                    ref="main"
                    :placeholder="$t(placeholder)"
                    v-model="showValue"
                    :size="size"
                    :clearable="disabled?false:clearable"
                    :disabled="disabled"
                    @clear="handleInputClear"
                    @focus="handleShow">
                        <span slot="append"
                                @click="handleShow">
                            <el-button slot="append" icon="fa fa-sitemap"></el-button>
                        </span>
                        <template slot="prepend" v-if="canSelectCurrent && !disabled">
                            <div class="flex pointer" style="justify-content: center;height: 100%;" :title="$t(currentName)" @click.stop="selectCurrent">
                                <i class="learun-icon-lock" :style="{'color': hasCurrent ? '#0D68FF' : '#8c8c8c'}"></i>
                            </div>
                        </template>
                    </el-input>
                </template>
            </template>
            <template v-else-if="mode == 'form'">
                <div class="flex" style="flex-wrap: wrap;">
                    <div class="add-btn" @click="handleShow" v-if="!disabled">
                        <i class="el-icon-plus"></i>
                        {{$t('添加公司')}}
                    </div>
                    <l-company :canRemove="!disabled" mode="form" @remove="removeHandler" v-for="i in (this.value ? this.value.split(',') : [])" :value="i" :key="i"/>
                </div>
            </template>
            <l-dialog 
                v-if="multiple"
                :title="$t(placeholder)"
                :visible.sync="dialogVisible"
                :height="480"
                :hasBtns="multiple"
                @ok="handleSelectMultiple"
                @opened="handleOpened"
                :width="400"
                >
                <l-layout class="l-tab-page">
                    <l-panel>
                        <template #toolLeft >
                            <div class="l-panel--item" style="width: 100%;" >
                                <el-input :placeholder="$t('请输入')" v-model="searchWord" size="mini" >
                                    <el-button slot="append" icon="el-icon-search"></el-button>
                                </el-input>
                            </div>
                        </template>
                        <el-tree :data="myOptions" :show-checkbox="multiple" ref="maintree" node-key="f_CompanyId" default-expand-all :expand-on-click-node="false" >
                            <span slot-scope="{ node}">
                                <i class="learun-icon-co"></i>
                                {{ $t(node.label) }}
                            </span>
                        </el-tree>
                    </l-panel>
                </l-layout>
            </l-dialog>
        </template>
    </div>
</template>

<script>

export default {
    name:'l-company-select',
    props: {
        value:{},
        size:{
            type:String,
            default:'mini'
        },
        placeholder:{
            type:String,
            default:'请选择'
        },
        disabled:Boolean,
        multiple:{
            type:Boolean,
            default:false
        },
        clearable:{
            type:Boolean,
            default:true
        },
        printMode: {
            default: false
        },
        mode: {
            default: 'normal', //form、 normal
        },
        canSelectCurrent: {
            default: false
        }
    },
    data () {
        return {
            dialogVisible:false,
            searchWord:'',
            currentName: '所属公司'
        }
    },
    computed:{
        showValue:{
            get(){
                let arr = this.value ? this.value.split(',') : [], brr = []
                if (arr.includes(this.currentName)) {
                    brr.push(this.$t(this.currentName))
                }
                if(this.lr_loadCompanyName){
                    brr = brr.concat(this.lr_loadCompanyName(arr.filter(e => e != this.currentName).join(',')))
                }
                else{
                    return this.value
                }
                return brr.filter(e => e).join(',')      
            },
            set(val){
                this.$emit('input',val)
            }
        },
        selectValue:{
            get(){
                return this.value;
            },
            set(val){
                this.$emit('input',val)
            }
        },
        hasCurrent () {
            if (!this.value) return false
            return this.value.indexOf(this.currentName) > -1
        },
        uidStr() {
            if (!this.vlaue) return ''
            return this.value.replace(`${this.currentName},`, '').replace(this.currentName, '')
        },
        myOptions(){
            let list = this.lr_companyList
            if(this.searchWord){
                list = list.filter(t=>t.f_FullName.indexOf(this.searchWord) != -1)
            }


            if(this.lr_companyList){
                if (this.multiple) return this.$toTree(list,"f_CompanyId","","f_CompanyId","f_FullName")
                return this.$toTree(list,"f_CompanyId","f_ParentId","f_CompanyId","f_FullName")
            }
            else{
                return []
            }
        }
    },
    created(){
        this.lr_loadCompanys && this.lr_loadCompanys()
    },
    methods:{
        selectCurrent() {
            let arr = this.value ? this.value.split(',') : []
            if (arr.includes(this.currentName)) {
                arr = arr.filter(e => e != this.currentName)
            } else {
                if (this.multiple) {
                    arr.unshift(this.currentName)
                } else {
                    arr = [this.currentName]
                }
            }
            let val = arr.join(',')
            this.$emit('input', val)
            this.$emit('change', val)
        },
        removeHandler (id) {
            let arr = this.value ? this.value.split(',') : []
            arr = arr.filter(e => e != id)
            // this.selectValue = arr.join(',')
            this.$emit('input', arr.join(','))
            this.handleChange(arr.join(','))
            console.log(this.value, 'this.value-------')
        },
        handleShow(){
            console.log(this.disabled, 'this.disabled-----')
            if(!this.disabled){
                this.dialogVisible = true
            }
        },
        handleInputClear(){
            this.handleChange()
        },
        handleChange(val){
            this.$emit('change',val)
        },
        handleOpened(){
            if(this.value){
                //this.$refs.maintree.setCheckedKeys(this.value.split(','),true)
            }
            else{
                this.$refs.maintree.setCheckedKeys([])
            }
        },
        handleSelectMultiple(){
            const checkedKeys = this.$refs.maintree.getCheckedKeys()
            const halfCheckedKeys = this.$refs.maintree.getHalfCheckedKeys()
            const selectValue = checkedKeys.concat(halfCheckedKeys)
            if (this.hasCurrent) {
                selectValue.unshift(this.currentName)
            }
            this.selectValue = String(selectValue)
            this.$refs.main && this.$refs.main.focus()
            this.$refs.main && this.$refs.main.blur()
            this.dialogVisible = false

            if(!this.selectValue){
                this.handleChange()
            }
            else{
                this.handleChange(this.lr_companyList.filter(t=>selectValue.indexOf(t.f_CompanyId) != -1))
            }
        }
    }
}
</script>
<style lang="less" scoped>
.add-btn {
    width: auto;
    padding: 0 12px;
    display: inline-block;
    font-size: 12px;
    color: #2c71fa;
    background: #f5f7f9;
    height: 28px;
    line-height: 28px;
    border-radius: 14px;
    margin: 4px 0;
    margin-right: 8px;
    cursor: pointer;
}
</style>